// extracted by mini-css-extract-plugin
export default {"wrapper":"V2QXW5kBJq","disabled":"dDRpqhNXRl","dot":"V2t1GH2T09","radio":"KmK2HzOjVf","label":"PtLvenrO40"};